// extracted by mini-css-extract-plugin
export default {"productCarousel":"L1-z"};